import Constants from 'common/constants'

import {REDUX_GET_TEACHERS} from '../../General/ActionTypes/ReduxActionTypes'
import {
  ADD_TEACHER,
  ADD_TEACHER_GENERAL_REMARKS,
  ADD_TEACHER_UPLOAD_FILE,
  DELETE_TEACHER_GENERAL_REMARKS,
  EMAIL_TEACHER_LOGIN_DETAILS,
  GENERATE_TEACHER_LIST_REPORT_PDF,
  GENERATE_TEACHER_LOGIN_REPORT,
  GET_ASSIGNED_STUDENTS,
  GET_TEACHER_BY_ID,
  GET_TEACHER_CHILDREN_BY_ID,
  GET_TEACHER_CLASSES_BY_ID,
  GET_TEACHER_EXPERIENCE_BY_ID,
  GET_TEACHER_FILE_TYPES,
  GET_TEACHER_GENERAL_REMARKS_BY_ID,
  GET_TEACHER_LIST,
  GET_TEACHER_QUALIFICATIONS_BY_ID,
  GET_TEACHER_SUBJECTS_BY_ID,
  GET_TEACHER_UPLOADED_FILES,
  IN_ACTIVATE_USER,
  SMS_TEACHER_LOGIN_DETAILS,
  UPDATE_TEACHER,
  UPDATE_TEACHER_GENERAL_REMARKS_BY_ID,
  UPLOAD_SIGNATURE_IMAGE,
} from './ActionTypes/ApiActionTypes'

export const getTeacherList = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TEACHER_LIST,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_get_teacher_list,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: reduxUpdate ? REDUX_GET_TEACHERS : '',
      onFailure,
    },
  }
}
export const getAssignedStudents = (body, onSuccess, onFailure) => {
  return {
    type: GET_ASSIGNED_STUDENTS,
    payload: {
      onSuccess,
      apiUrl: Constants.api_get_teacher_assigned_students,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const getTeacherById = (id, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_BY_ID,
    payload: {
      apiUrl: Constants.api_get_teacher_info_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const inActivateUser = (id, onSuccess, onFailure) => {
  return {
    type: IN_ACTIVATE_USER,
    payload: {
      apiUrl: Constants.api_in_activate_teacher_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getTeacherClassesById = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_CLASSES_BY_ID,
    payload: {
      apiUrl: Constants.api_get_teacher_classes_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getTeacherSubjectsById = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_SUBJECTS_BY_ID,
    payload: {
      apiUrl: Constants.api_get_teacher_subjects_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}
export const getTeacherQualificationsById = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_QUALIFICATIONS_BY_ID,
    payload: {
      apiUrl: Constants.api_get_teacher_qualification_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getTeacherExperienceById = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_EXPERIENCE_BY_ID,
    payload: {
      apiUrl: Constants.api_get_teacher_experience_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}
export const getTeacherChildrenById = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_CHILDREN_BY_ID,
    payload: {
      apiUrl: Constants.api_get_teacher_children_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const updateTeacher = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_TEACHER,
    payload: {
      apiUrl: Constants.api_update_teacher_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const addTeacher = (data, onSuccess, onFailure) => {
  return {
    type: ADD_TEACHER,
    payload: {
      apiUrl: Constants.api_create_teacher,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const deleteTeacherGeneralRemarks = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_TEACHER_GENERAL_REMARKS,
    payload: {
      apiUrl: Constants.api_del_teacher_destroy_general_remarks(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getTeacherGeneralRemarksById = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_GENERAL_REMARKS_BY_ID,
    payload: {
      apiUrl: Constants.api_get_teacher_general_remarks_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body,
      onSuccess,
      onFailure,
    },
  }
}
export const addTeacherGeneralRemarks = (id, body, onSuccess, onFailure) => {
  return {
    type: ADD_TEACHER_GENERAL_REMARKS,
    payload: {
      apiUrl: Constants.api_add_teacher_general_remarks_by_id(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const updateTeacherGeneralRemarksById = (id, body, onSuccess, onFailure) => {
  return {
    type: UPDATE_TEACHER_GENERAL_REMARKS_BY_ID,
    payload: {
      apiUrl: Constants.api_update_teacher_general_remarks_ById(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTeacherUploadedFiles = (id, body, onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_UPLOADED_FILES,
    payload: {
      apiUrl: Constants.api_get_teacher_uploaded_files(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}
export const getTeacherFileTypes = (onSuccess, onFailure) => {
  return {
    type: GET_TEACHER_FILE_TYPES,
    payload: {
      apiUrl: Constants.api_get_teacher_file_types,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const addTeacherUploadFile = (id, body, onSuccess, onFailure) => {
  return {
    type: ADD_TEACHER_UPLOAD_FILE,
    payload: {
      apiUrl: Constants.api_add_teacher_upload_file(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const generateLoginReport = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_LOGIN_REPORT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_generate_teacher_login_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const smsLoginDetails = (data, onSuccess, onFailure) => {
  return {
    type: SMS_TEACHER_LOGIN_DETAILS,
    payload: {
      apiUrl: Constants.api_sms_teacher_login_details,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const emailLoginDetails = (data, onSuccess, onFailure) => {
  return {
    type: EMAIL_TEACHER_LOGIN_DETAILS,
    payload: {
      apiUrl: Constants.api_email_teacher_login_details,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}
export const generateTeacherListReportPDF = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_TEACHER_LIST_REPORT_PDF,
    payload: {
      onSuccess: onSuccess,
      apiUrl: Constants.api_generate_teacher_list_report_pdf,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const confirmSignaturePictureUpload = (id, body, onSuccess, onFailure) => {
  return {
    type: UPLOAD_SIGNATURE_IMAGE,
    payload: {
      onSuccess,
      onFailure,
      apiUrl: Constants.api_confirm_signature_picture_upload(id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body,
      reduxActionType: '',
    },
  }
}
